import type { ISchedulingBoardCache } from "@ports/shifts/ISchedulingBoardCache";
import type { ISchedulingBoardReads } from "@ports/shifts/ISchedulingBoardReads";
import { API } from "../api";
import { BACKLOG_TTL_MS } from "./data/tables/jobs";
import { CachedAPI } from "./index";

/** The Scheduling board's reads: shifts and stops through their client caches, jobs live. */
export const schedulingBoardReads: ISchedulingBoardReads = {
	shiftsSince: (cutoff) => CachedAPI.Data.Shifts.sinceCutoff.get(cutoff),
	stopsSince: (cutoff) => CachedAPI.Data.ShiftDropoffs.sinceCutoff.get(cutoff),
	jobsByIds: (ids) => API.Data.Jobs.get.byIds(ids),
	jobsModifiedSince: (since) => API.Data.Jobs.get.modifiedSince(since),
};

// Resolved per call, not at import: tests that mock the cached API without its job lists still
// import this module through the use-case wiring.
const jobList = (list: "backlog" | "scheduledJobs") =>
	list === "backlog" ? CachedAPI.Data.Jobs.unscheduled : CachedAPI.Data.Jobs.scheduledUnsampled;

/** The caches behind the board's lists. */
export const schedulingBoardCache: ISchedulingBoardCache = {
	listsMaxAgeMs: BACKLOG_TTL_MS,
	invalidate: (list) => {
		if (list === "shifts") CachedAPI.Data.Shifts.sinceCutoff.clear();
		else if (list === "stops") CachedAPI.Data.ShiftDropoffs.sinceCutoff.clear();
		else CachedAPI.Data.Jobs.unscheduled.clear();
	},
	updateJobs: (list, change) => jobList(list).update(change),
};
